var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9ed32;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.45,9.46h10.41c1,0,1.73,.16,2.17,.47,.45,.31,.67,.83,.67,1.54,0,.44-.26,1.02-.79,1.74-.52,.72-1.12,1.51-1.8,2.38-.66,.87-1.36,1.95-2.07,3.24-.71,1.29-1.37,2.87-1.96,4.73-.25,.83-.43,1.51-.54,2.05-.1,.54-.21,1.25-.34,2.11-.13,.87-.23,1.53-.32,1.99-.22,1.06-.54,1.8-.94,2.21-.4,.41-.93,.62-1.6,.62-.63,0-1.14-.22-1.52-.66-.39-.44-.59-1.09-.59-1.96,0-.66,.15-1.57,.43-2.71,.27-1.15,.73-2.52,1.37-4.12,.63-1.6,1.44-3.24,2.38-4.92,.96-1.68,2.09-3.35,3.4-5.02H15.45c-.87,0-1.52-.16-1.95-.48-.44-.32-.65-.82-.65-1.49,0-.72,.23-1.18,.69-1.39,.46-.21,1.09-.31,1.91-.31Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT7);
export default __webpack_public_path__ + "static/media/T7.317f787a095f8e2083e1f94ebb15defe.svg";
export { ForwardRef as ReactComponent };